import newRequest from "../utils/newRequest";

/// get pinned questions
export const getPinnedQuestionsApi = (page = 1, limit = 10) => {
  let result = newRequest.get(
    `/posts/crm?page=${page}&limit=${limit}&sponsierd=${true}`
  );
  return result;
};
